import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, reduxForm} from 'redux-form';
import {SelectInput} from 'admin-on-rest';
import FormattedDateTextInput from '../components/FormattedDateTextInput';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';
import {viewStyles} from '../shared/styles-view';
import TextField from 'material-ui/TextField';

/**
 * Set a field for filter entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
        />
    )
};

class TransferredProductsSearchFilter extends Component {

    handleFilterSubmit = () => {
        if (typeof this.props.onSubmitFilter === 'function') {
            this.props.onSubmitFilter({
                date: this.props.filterDateSince,
                receivedCondition: this.props.filterReceived,
                searchName: this.props.filterSearch,
                transferType: this.props.filterType
            });
        }
    };

    isDisabled = (props) => {
        const {
            filterDateSince,
            filterReceived,
            filterSearch,
            filterType,
            loading
        } = props;
        return (
            loading ||
            !filterDateSince ||
            filterReceived === '' ||
            !filterSearch ||
            filterSearch === '' ||
            filterSearch.length < 3 ||
            filterType === ''
        );
    };

    render() {

        const styles = {
            selectContainer: {display: 'inline-block', marginRight: 10, marginBottom: '-1px', verticalAlign: 'bottom'}
        };

        const disabled = this.isDisabled(this.props);

        return (
            <form>
                <div className="list-filter">
                    <span style={viewStyles.filterInline}>
                        <FormattedDateTextInput
                            formName="filterForm"
                            source="filter_date_since"
                            label="Select Since Date"
                            placeholder="MM/DD/YYYY"
                            maxDate={new Date()}
                            allowInputValue={false}
                            style={viewStyles.filterDateSelect}
                        />
                    </span>
                    <span style={styles.selectContainer}>
                        <Field
                            name="filter_received"
                            component={SelectInput}
                            choices={[
                                {id: 'any', name: 'Any Status'},
                                {id: 'unreceived', name: 'Incoming Transfer'},
                                {id: 'received', name: 'Received Transfer'}
                            ]}
                            defaultValue="any"
                            label="Select Transfer Status"
                            elStyle={viewStyles.rowShowFieldWide}
                        />
                    </span>
                    <span style={styles.selectContainer}>
                        <Field
                            name="filter_type"
                            component={SelectInput}
                            choices={[
                                {id: 'any', name: 'Any Transfer'},
                                {id: 'repack', name: 'Repack'},
                                {id: 'retailbox', name: 'Retail Box'}
                            ]}
                            defaultValue="any"
                            label="Transfer Type"
                            elStyle={viewStyles.rowShowFieldWide}
                        />
                    </span>
                    <Field
                        id="filter_search"
                        name="filter_search"
                        type="text"
                        component={renderInput}
                        floatingLabelText="Enter a Product Name"
                        style={filterStyles.textInputWide}
                    />
                    <RaisedButton
                        primary
                        type="button"
                        label="Search"
                        disabled={disabled}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButton}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['filterForm'];
    if (form && form.values) {
        return {
            filterDateSince: form.values.filter_date_since,
            filterReceived: form.values.filter_received,
            filterSearch: form.values.filter_search,
            filterType: form.values.filter_type
        }
    }
    return {
        filterDateSince: null,
        filterReceived: '',
        filterSearch: '',
        filterType: ''
    }
};

TransferredProductsSearchFilter.propTypes = {
    loading: PropTypes.bool,
    onSubmitFilter: PropTypes.func
};

const enhance = compose(
    connect(
        mapStateToProps
    ),
    reduxForm({
        form: 'filterForm'
    })
);

export default enhance(TransferredProductsSearchFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferredProductsSearchFilter.js